import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { DepartmentAdministrationTabs } from '@modules/department/models/department-administration-tabs.enum';
import { ScrollHeaderTitleDirective } from '@modules/shared/directives/scroll-header-title.directive';
import { MenuEntry } from '@shared/models/base/menu-entry';
import { injectTabSlideDirection } from '@shared/utils/tab-slide-direction';
import { TuiTitle } from '@taiga-ui/core';
import { TuiTabs } from '@taiga-ui/kit';
import { TuiHeader, TuiNavigation, TuiSlides } from '@taiga-ui/layout';
import { DepartmentAvatarComponent } from '../department-avatar/department-avatar.component';
import { DepartmentAdminService } from './department-admin.service';

@Component({
  selector: 'pxc-department-admin',
  imports: [
    TuiSlides,
    CommonModule,
    DepartmentAvatarComponent,
    RouterModule,
    ScrollHeaderTitleDirective,
    TranslocoDirective,
    TuiHeader,
    TuiNavigation,
    TuiTabs,
    TuiTitle,
  ],
  providers: [DepartmentAdminService],
  templateUrl: './department-admin.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DepartmentAdminComponent {
  private readonly departmentAdminService = inject(DepartmentAdminService);
  private readonly translocoService = inject(TranslocoService);

  readonly department$ = this.departmentAdminService.department$;

  tabs: MenuEntry[] = [
    {
      title: this.translocoService.translate('Utilisateurs'),
      link: DepartmentAdministrationTabs.USERS,
    },
    {
      title: this.translocoService.translate('Mots clés'),
      link: DepartmentAdministrationTabs.LABELS,
    },
    {
      title: this.translocoService.translate('Paramètres'),
      link: DepartmentAdministrationTabs.SETTINGS,
    },
  ];

  readonly slideDirection = injectTabSlideDirection(this.tabs.map(({ link }) => link));
}
